export const CommonConstants = {
  DisplayScrollTopButtonPaths: [
    "/home",
    "/weddinghall/search",
    "/weddinghall/home",
    "/product/weddinghall",
    "/product/planning",
    "/planners",
    "/planner/portfolios",
    "/partner-list",
    "/product",
  ],
};
